@if (info(); as info) {
  <vwui-tooltip class="version-tooltip" position="top-end">
    <span class="version-tooltip__version">{{ 'COMPONENT.version' | translate:{version: info.git.version} }}</span>
    <div slot="label" class="version-tooltip__content">
      <div class="version-tooltip__entry">
        <small class="version-tooltip__date">{{ 'COMPONENT.version_info.tag' | translate }}</small>
        <div class="version-tooltip__subject">{{ info.git.closestTag }}</div>
      </div>
      <div class="version-tooltip__entry">
        <small class="version-tooltip__date">{{ 'COMPONENT.version_info.commit' | translate }}</small>
        <div class="version-tooltip__subject">{{ info.git.commitId.slice(0, 8) }}</div>
      </div>
      <div class="version-tooltip__entry">
        <small class="version-tooltip__date">{{ 'COMPONENT.version_info.commit_time' | translate }}</small>
        <div class="version-tooltip__subject">{{ info.git.commitTime | date: ('DATE.short' | translate) }}</div>
      </div>
    </div>
  </vwui-tooltip>
}
